import styled from 'styled-components';
import { COLORS } from 'modules/core/theme/colors';
import { Table } from 'react-bootstrap';

import { IAvailableDealStructureStatus } from '../types';
import { AVAILABLE_DEAL_STRUCTURE_STATUSES } from '../consts/consts';

export const TableWrapper = styled(Table)`
  tbody,
  td,
  tfoot,
  th,
  thead,
  tr {
    border-style: hidden;
  }

  background-color: ${COLORS.GREY_30};
`;

export const TableHeader = styled.thead`
  position: sticky;
  top: -3px;
  color: ${COLORS.GREY_5};
  font-weight: bold;

  tr th:nth-child(2) {
    width: 12%;
  }
  tr th:nth-child(3),
  tr th:nth-child(4),
  tr th:nth-child(5),
  tr th:nth-child(6) {
    width: 13%;
  }
  tr th:nth-child(7) {
    width: 16%;
  }
  tr th:first-child {
    width: 1%;
  }
  tr th:last-child {
    width: 1%;
  }
`;

export const TableBody = styled.tbody<{
  status: IAvailableDealStructureStatus;
}>`
  td {
    text-align: center;
    vertical-align: middle;
  }
  tr:nth-child(2n - 1) {
    background-color: ${COLORS.WHITE};
  }
  tr:first-child {
    outline: 2px solid ${({ status }) => status.tableColor};
    outline-offset: -2px;
  }

  ${({ status }) =>
    status !== AVAILABLE_DEAL_STRUCTURE_STATUSES.MISSING_OR_INVALID_INFO &&
    `
      tr:first-child {
        font-weight: bold;
        color: ${status.tableColor};
      }

      tr:first-child td:first-child {
        position: relative;
      }

      tr:first-child td:first-child:before {
        content: '\u25CF';
      }
    `}
`;

export const TableHeaderCell = styled.th`
  text-align: center;
  font-size: 14px;
  vertical-align: middle;
`;

export const TableCell = styled.td``;
